import { render, staticRenderFns } from "./AddToImageGroupModal.vue?vue&type=template&id=3c26f958&scoped=true"
import script from "./AddToImageGroupModal.vue?vue&type=script&lang=js"
export * from "./AddToImageGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddToImageGroupModal.vue?vue&type=style&index=0&id=3c26f958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c26f958",
  null
  
)

export default component.exports